export default __webpack_public_path__ + "static/media/OUTSTANDINGPAYMENT.b1068f28.png";